module.exports = __webpack_public_path__ + "img/logo_harrer.8285646a.png";